<template>
    <el-dialog class="dialog" title="添加已有用户" v-if="addjuese" :visible.sync="addjuese" width="80%" top="10vh">
        <!-- 搜索已有用户 -->
        <el-popover placement="bottom" width="700" trigger="hover" @show="getList">
            <el-table size="mini" :data="list" v-loading="listLoading" height='300' :show-header="false" :empty-text="emptytext">
                <el-table-column property="username" label="" width="170"></el-table-column>
                <el-table-column property="realname" label="" width="160"></el-table-column>
                <el-table-column property="email" label=""></el-table-column>
                <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button v-if="scope.row.choose" type="text" class="bdc-table-op-muted" disabled>已添加</el-button>
                      <el-button v-else type="text" class="bdc-table-op-muted" @click="tianjiayaoqing(scope.row)">添加</el-button>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            <div slot="reference"  style="width:460px;margin: 0 40px 20px; display: flex; flex-flow: row nowrap;align-items: center;">
                <label style="width:60px">搜索：</label>
                <el-input v-model="search" size="small" clearable  placeholder="请输入已有用户登录名或邮箱或真实姓名进行搜索" > 
                    <el-button slot="append" size="small"  type="primary" icon="el-icon-search" @click="statechaxun"></el-button>
                </el-input>
                
            </div>
        </el-popover>

        <!-- 显示要添加的用户-->
        <el-table class="grayTableTile" size="mini" height="458"  :data="tableList.slice((listQuery.pageNo-1)*listQuery.pageSize,listQuery.pageNo*listQuery.pageSize)" border style="width: 100%" empty-text="请搜索并添加已有用户">
            <el-table-column prop="username" label="登录名"></el-table-column>
            <el-table-column prop="realname" label="姓名"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-danger" @click="shanchuyaoqing(scope.$index, scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0; padding: 10px 0" />

        <!-- 按钮组 -->
        <div class="dialog-butn-box" style="margin-top: 10px">
            <el-button size="mini" type="primary" :disabled="tableList.length < 1" :loading='butnLoading' @click="handleSave">确认</el-button>
            <el-button size="mini" @click="addjuese=false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination'
import {userinviteget,userfindByName, userinvite} from '@Sys~/api/sys'
export default {
    components: {Pagination},
    data() {
        return {
            addjuese: false, // 对话框
            emptytext: "未匹配到已有用户，请尝试用其他内容搜索",
            listLoading: false,
            listSource:[], // 已有用户
            listData:[],
            search: '',

            // 已选用户
            tableList:[],
            total: 0,
            listQuery: {
                pageNo: 1,
                pageSize: 10
            },
            butnLoading: false

        }
    },

    computed: {
        list:{
            get() {
                const search = this.search.toLowerCase().replace(/\s+/g,"");
                if(search) {
                    return this.listData.filter(data => {
                        return String(data['username']).toLowerCase().indexOf(search) > -1 
                                || String(data['realname']).toLowerCase().indexOf(search) > -1
                                || String(data['email']).toLowerCase().indexOf(search) > -1
                    })
                }

                return this.listData
            }
        }
    },

    methods: {

        init() {
            this.addjuese = true
            this.search = ''
            this.listSource = []
            this.listData = []
            this.tableList = []
            this.total = 0
        },

        // 获取已用户列表
        getList() {
            this.listLoading = true
            this.listData = []
            if(this.listSource.length > 0) {
                setTimeout(() => {
                    this.listLoading = false
                    this.listData = this.listSource
                }, 80)  
                
                return
            }
            userinviteget().then(response => {
                this.listLoading = false
                if(response.code == 1) {
                    this.listSource = response.data
                    this.listData = this.listSource
                }
            })
        },

        // 搜索集团外用户
        statechaxun() {
            console.log(this.list)
            if(this.search && this.list.length == 0) {
                userfindByName(this.search).then(response => {
                    if (response.code == 1) {
                        this.listData = response.data
                    }
                });
            }
        },

        // 添加
        tianjiayaoqing(row) {
            row.choose = true
            this.tableList.push(row)
            this.total = this.tableList.length
        },

        // 删除已选用户
        shanchuyaoqing(index, row) {
            this.tableList.splice(index, 1);
            row.choose = false
            this.total = this.tableList.length
        },

        // 确认
        handleSave() {
            this.butnLoading = true
            const ids = []
            this.tableList.forEach(item => {
                ids.push(item.id)
            });

            const data = {
                ids: ids,
                name: this.search
            }

            userinvite(data).then(response => {
                if (response.code == 1) {
                    this.$message({
                        message: "添加成功",
                        type: "success"
                    });
                    this.addjuese = false;
                    this.butnLoading = false
                    this.$emit('getAgainList')
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog__body{
            padding: 8px 20px 15px;
        }
    }
</style>